import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

import NotificationItem from "ui/Items/NotificationItem";

import {
  navbar,
  navbarContainer,
  navbarIconButton,
  navbarMobileMenu,
} from "ui/Navbars/DashboardNavbar/styles";

import { useMaterialUIController, setTransparentNavbar, setMiniSidenav } from "context";
import { Tooltip } from "@mui/material";

// import bannerImg1 from "assets/images/identite/banner.png";

import { makeStyles } from "@mui/styles";
import PswUpdateComponent from "ui/Navbars/DashboardNavbar/component/PswUpdateComponent";
import { PATH_LOGOUT } from "constant/moduleInfo";
import MDBox from "components/MDBox";
import userInfos from "utils/userInfos";

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: "#2196f3",
    color: "#fff",
    padding: theme.spacing(2),
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  bannerImage: {
    maxWidth: "100%",
    height: "auto",
    width: "100%",
  },
}));
function DashboardNavbar({ absolute, light, isMini }) {
  const navigate = useNavigate();
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [openDialogUser, setOpenDialogUser] = useState(false);
  const connectedUser = userInfos();
  const { REACT_APP_CODE_CLIENT } = process.env;

  // const bannerImg = `../assets/images/identite/${REACT_APP_CODE_CLIENT}/banner.png`;
  const bannerContext = require.context("assets/images/identite", true, /banner\.png$/);
  const bannerImg = bannerContext(`./${REACT_APP_CODE_CLIENT}/banner.png`);
  // console.log("sss ", bannerImg, bannerImg1);

  const classes = useStyles();
  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);

    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const handleCloseMenu = () => setOpenMenu(false);
  const handleUserDialog = () => setOpenDialogUser(!openDialogUser);

  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" />
    </Menu>
  );

  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  const handleLogout = () => {
    // console.log("handleLogout", PATH_LOGOUT);
    navigate(PATH_LOGOUT);
  };
  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      {/* <Suspense fallback={<div>...</div>}> */}
      <MDBox
        variant="gradient"
        bgColor="inherit"
        borderRadius="lg"
        coloredShadow="info"
        mx={2}
        mt={-3}
        p={2}
        mb={10}
        textAlign="center"
        position="relative"
      >
        <img src={bannerImg} className={classes.bannerImage} alt="Beta Click" />
        {/* <img src="assets/images/banner.png" className={classes.bannerImage} alt="Beta Click" /> */}
      </MDBox>
      {/* <ResponsiveBanner /> */}
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {/* <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox> */}
        {isMini ? null : (
          <MDBox /* sx={{ marginLeft: "auto" }} */>
            {/* <MDBox sx={(theme) => navbarRow(theme, { isMini })}> */}
            {/* <MDBox pr={1}>
              <MDInput label="Search here" />
            </MDBox> */}
            <MDBox color={light ? "white" : "inherit"}>
              {/* <Link to="/authentication/sign-in/basic">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </Link> */}
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              <Tooltip title="Mon Compte" arrow>
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={handleUserDialog}
                >
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Se Déconnecter" arrow>
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={handleLogout}
                >
                  <Icon sx={iconsStyle}>power_settings_new</Icon>
                </IconButton>
              </Tooltip>
              {openDialogUser && (
                <PswUpdateComponent
                  open={openDialogUser}
                  handleClose={handleUserDialog}
                  connectedUser={connectedUser}
                />
              )}
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
      {/* </Suspense> */}
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
